import React from 'react';
import { ArrowRightLeftIcon } from 'lucide-react';
import { SubstitutionPreference, useStore } from '../../lib/store';
const options: {
  id: SubstitutionPreference;
  label: string;
  description: string;
}[] = [{
  id: 'allow',
  label: 'Show me the best substitute',
  description: 'We will recommend a similar item, and you confirm it before replacement.'
}, {
  id: 'contact',
  label: 'Contact me first',
  description: 'We will ask before replacing an unavailable item.'
}, {
  id: 'cancel',
  label: 'Remove unavailable items',
  description: 'Continue the order without unavailable items.'
}];
export function NowSubstitutionPreference() {
  const preference = useStore(state => state.substitutionPreference);
  const setPreference = useStore(state => state.setSubstitutionPreference);
  return <section className="rounded-xl border border-brand-border bg-white p-4" aria-labelledby="substitution-heading" data-id="element-4316" data-mp="3sa5rlt3g6it2">
      <div className="flex items-start gap-2" data-id="element-4317" data-mp="13bdatjqfhu1">
        <ArrowRightLeftIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-4318" data-mp="16h5wirkl1ui" />
        <div data-id="element-4319" data-mp="ovxvvkqtuxch">
          <h2 id="substitution-heading" className="text-sm font-bold text-brand-ink" data-id="element-4320" data-mp="juqp9p0f847e">If an item becomes unavailable</h2>
          <p className="mt-1 text-xs leading-4 text-brand-muted" data-id="element-4321" data-mp="xv1gwu9k1mtm">Choose how our pharmacist should handle a suitable alternative.</p>
        </div>
      </div>
      <fieldset className="mt-3 space-y-2" data-id="element-4322" data-mp="tqtp2o7svqr6">
        <legend className="sr-only" data-id="element-4323" data-mp="62u0nuxyocfr">Substitution preference</legend>
        {options.map(option => <label key={option.id} className={`flex cursor-pointer items-start gap-3 rounded-lg border p-3 transition-colors duration-150 ${preference === option.id ? 'border-brand bg-brand-light' : 'border-brand-border hover:bg-gray-50'}`} data-id="element-4324" data-mp="151xg4rv93w9">
            <input type="radio" name="substitution" value={option.id} checked={preference === option.id} onChange={() => setPreference(option.id)} className="mt-0.5 h-4 w-4 border-brand-border text-brand focus:ring-brand" data-id="element-4325" data-mp="a3npcqj89v9p" />
            <span data-id="element-4326" data-mp="3ehc9vzzn1y0y"><span className="block text-sm font-bold text-brand-ink" data-id="element-4327" data-mp="1hiiw5ybvg603">{option.label}</span><span className="mt-0.5 block text-xs leading-4 text-brand-muted" data-id="element-4328" data-mp="1hggatrlnz11p">{option.description}</span></span>
          </label>)}
      </fieldset>
    </section>;
}